import React, { useState, useEffect } from 'react';
import { Shield, ChevronDown } from 'lucide-react';

const SelectorRoles = ({ value, onChange, disabled, isDarkMode }) => {
 const [roles, setRoles] = useState([]);
 const [loading, setLoading] = useState(false);
 const [isOpen, setIsOpen] = useState(false);

 useEffect(() => {
   loadRoles();
 }, []);

 const loadRoles = async () => {
   setLoading(true);
   
   try {
     const token = sessionStorage.getItem('mapasac_access_token');
     const response = await fetch('/api/roles', {
       headers: {
         'Authorization': `Bearer ${token}`,
         'Content-Type': 'application/json'
       }
     });
     
     const data = await response.json();
     
     if (data.success) {
       setRoles(data.data.roles || []);
     } else {
       console.error('Error cargando roles:', data);
       setRoles([]);
     }
   } catch (error) {
     console.error('Error de conexión:', error);
     setRoles([]);
   } finally {
     setLoading(false);
   }
 };

 const selectedRol = roles.find(rol => rol.idrol === value);

 const handleSelect = (rol) => {
   onChange(rol.idrol);
   setIsOpen(false);
 };

 return (
   <div className="relative">
     <button
       type="button"
       onClick={() => !disabled && !loading && setIsOpen(!isOpen)}
       disabled={disabled || loading}
       className={`w-full flex items-center justify-between px-3 py-2 border rounded-lg text-left transition-colors ${
         disabled || loading
           ? isDarkMode 
             ? 'bg-gray-600 border-gray-500 text-gray-400 cursor-not-allowed' 
             : 'bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed'
           : isDarkMode
             ? 'bg-gray-700 border-gray-600 text-white hover:bg-gray-600 focus:ring-2 focus:ring-blue-500'
             : 'bg-white border-gray-300 text-gray-900 hover:bg-gray-50 focus:ring-2 focus:ring-blue-500'
       }`}
     >
       <div className="flex items-center">
         <Shield size={16} className={`mr-2 ${disabled || loading ? 'text-gray-400' : 'text-blue-600'}`} />
         <span className="truncate">
           {loading 
             ? 'Cargando roles...' 
             : selectedRol 
               ? selectedRol.nombre 
               : 'Seleccionar rol...'
           }
         </span>
       </div>
       <ChevronDown 
         size={16} 
         className={`transition-transform ${isOpen ? 'rotate-180' : ''} ${
           disabled || loading ? 'text-gray-400' : isDarkMode ? 'text-gray-300' : 'text-gray-500'
         }`} 
       />
     </button>

     {isOpen && !disabled && !loading && (
       <>
         {/* Overlay para cerrar el dropdown */}
         <div 
           className="fixed inset-0 z-10" 
           onClick={() => setIsOpen(false)}
         ></div>
         
         {/* Dropdown */}
         <div className={`absolute z-20 w-full mt-1 border rounded-lg shadow-lg max-h-60 overflow-y-auto ${
           isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
         }`}>
           {roles.length === 0 ? (
             <div className={`px-3 py-2 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
               No hay roles disponibles
             </div>
           ) : (
             roles.map((rol) => (
               <button
                 key={rol.idrol}
                 type="button"
                 onClick={() => handleSelect(rol)}
                 className={`w-full px-3 py-2 text-left text-sm transition-colors ${
                   isDarkMode 
                     ? 'hover:bg-gray-600 text-white' 
                     : 'hover:bg-blue-50 text-gray-900'
                 } ${value === rol.idrol 
                     ? isDarkMode 
                       ? 'bg-blue-600 text-white' 
                       : 'bg-blue-100 text-blue-800' 
                     : ''
                 }`}
               >
                 <div className="flex items-center">
                   <Shield size={14} className="mr-2 text-blue-600" />
                   <div>
                     <div className="font-medium">{rol.nombre}</div>
                     {rol.descripcion && (
                       <div className={`text-xs mt-1 ${
                         isDarkMode ? 'text-gray-400' : 'text-gray-500'
                       }`}>
                         {/*rol.descripcion*/}
                       </div>
                     )}
                   </div>
                 </div>
               </button>
             ))
           )}
         </div>
       </>
     )}
   </div>
 );
};

export default SelectorRoles;